import { forwardRef, createElement } from 'react';
import { b as __rest, z as Dropdown$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var Dropdown = /*#__PURE__*/forwardRef(function (_a, ref) {
  var props = __rest(_a, ["iconBrand"]);
  return /*#__PURE__*/createElement(Dropdown$1, __assign({
    iconBrand: "uq-ec-"
  }, props, {
    ref: ref
  }));
});
Dropdown.displayName = 'Dropdown';

export { Dropdown };
